import { MapServerProvider } from 'providers/request'
import { Legend } from 'models/legend'

export const LegendRepository = {
  fetchLegends(layerIds: number[]): Promise<Legend[]> {
    return MapServerProvider.get(`/getLegends?layersIds=${layerIds.join(',')}`)
  },
}
